module.exports = __webpack_public_path__ + "img/2026big6.57921106.png";